import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: false,
  isLoggedIn: false,
  isRegistered: false
};

const user = createSlice({
  name: "user",
  initialState,
  reducers: {
    updateAuth: (state, { payload }) => {
      state.isAuthenticated = payload;
    },
    updateIsLoggedIn: (state, { payload }) => {
      state.isLoggedIn = payload;
    },
    updateIsRegistered: (state, { payload }) => {
      state.isRegistered = payload;
    },
  },
});

export const { updateAuth, updateIsLoggedIn, updateIsRegistered } = user.actions;
export default user.reducer;
